import {useCallback, useEffect, useState} from "react";
import {execFn, getBase64Image} from "../../../common/generic-react.functions.js";
import {useStateWithCallbackLazy} from "../../../hooks/state-with-callback.hook.js";
export function useImageUploader({
  hasCrop,
  value,
  onUpload
}) {
  const [srcImage, setSrcImage] = useState("");
  const [imgInfo, setImgInfo] = useState(null);
  const [resultImage, setResultImage] = useStateWithCallbackLazy("");
  const [src, setSrc] = useStateWithCallbackLazy("");
  const [show, setShow] = useState(false);
  const [imageName, setImageName] = useState("image.jpg");
  const parseFileReader = useCallback((file, files) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const result = reader.result;
      if (result) {
        if (files) {
          execFn(onUpload, files);
        }
        setSrcImage(result);
        if (hasCrop && files) {
          setShow(true);
        } else {
          setResultImage(result);
        }
      }
    });
    reader.readAsDataURL(file);
  }, [hasCrop, onUpload, setResultImage]);
  const parseUpload = useCallback((files) => {
    if (!files || !files.length) {
      return;
    }
    setShow(false);
    const file = files[0];
    setImgInfo(file);
    setImageName(file.name);
    parseFileReader(file, files);
  }, [parseFileReader]);
  const fileDrop = useCallback((e) => {
    e.preventDefault();
    const {
      files
    } = e.dataTransfer;
    parseUpload(files);
    if (files && files.length) {
      parseUpload(files);
    }
  }, [parseUpload]);
  const fileUpload = useCallback((e) => {
    e.preventDefault();
    const {
      files
    } = e.target;
    parseUpload(files);
  }, [parseUpload]);
  useEffect(() => {
    if (value) {
      const res = value.startsWith("data:") ? ["image.jpg"] : value.match(/\b[^/]*$/gi);
      const name = res ? res[0] : "image.jpg";
      setImageName(name);
      const img = document.createElement("img");
      img.crossOrigin = "anonymous";
      img.src = value;
      img.onload = () => {
        setSrc(getBase64Image(img));
      };
    }
  }, [setSrc, value]);
  return {
    fileDrop,
    fileUpload,
    imgInfo: [imgInfo, setImgInfo],
    imageName: [imageName, setImageName],
    show: [show, setShow],
    resultImage: [resultImage, setResultImage],
    src: [src, setSrc],
    srcImage: [srcImage, setSrcImage]
  };
}
